interface ICategoryImageMapInterface {
    [key: string]: string;
}

export const categoryImageMap: ICategoryImageMapInterface = {
    alternative: "/images/categories/alternative.png",
    cheese: "/images/categories/cheese.png",
    condiment: "/images/categories/condiment.png",
    dairy: "/images/categories/dairy.png",
    egg: "/images/categories/egg.png",
    fermented: "/images/categories/fermented.png",
    fruit: "/images/categories/fruit.png",
    grain: "/images/categories/grain.png",
    legume: "/images/categories/legume.png",
    meat: "/images/categories/meat.png",
    misc: "/images/categories/misc.png",
    nutseed: "/images/categories/nutseed.png",
    oil: "/images/categories/oil.png",
    seafood: "/images/categories/seafood.png",
    sweetener: "/images/categories/sweetener.png",
    vegetable: "/images/categories/vegetable.png",
    vinegar: "/images/categories/vinegar.png",
    spice: "/images/categories/spice.png",
};
